import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { Injectable } from '@angular/core'
import { Actions, Effect } from '@ngrx/effects'
import { Action, select, Store } from '@ngrx/store'

import { Observable, of } from 'rxjs'

import { OrderService } from '../services/orders.service'

import * as meta from '../actions/meta'
import * as facet from '../actions/facets'
import * as order from '../actions/orders'

import * as fromOrders from '../reducers'

@Injectable()
export class FacetEffects {
    constructor(
        private actions$: Actions,
        private store: Store<fromOrders.State>,
        private orderSvc: OrderService
    ) { }

    @Effect()
    initFacetGroups$: Observable<Action> = 
        this.actions$.ofType<facet.InitGroups>(facet.INIT_GROUPS).pipe(
            switchMap(action => 
                this.orderSvc.getFacetGroups().pipe(
                    map(groups => new facet.InitGroupsSuccess(groups)),
                    catchError(e => of(new facet.InitGroupsFailed(e))),)
            ))

    @Effect()
    initFacets$: Observable<Action> = 
        this.actions$.ofType<facet.InitFacets>(facet.INIT_FACETS).pipe(
            switchMap(action =>
                this.orderSvc.getFacets().pipe(
                    map(facets => new facet.InitFacetsSuccess(facets)),
                    catchError(e => of(new facet.InitFacetsFailed(e))),)
            ))

    @Effect()
    initCompleted$: Observable<Action> =
        this.actions$.ofType<Action>(meta.INIT_SUCCESS, meta.INIT_SKIPPED).pipe(
            map(action => new facet.Load()))

    @Effect()
    loadFacets$: Observable<Action> = 
        this.actions$.ofType<facet.Load>(facet.LOAD).pipe(
            withLatestFrom(
                this.store.pipe(select(fromOrders.getAppliedFacets)),
                (action, applied) => applied
            ),
            switchMap(applied =>
                this.orderSvc.getFacetCounts(applied).pipe(
                    map(counts => new facet.LoadSuccess(counts)),
                    catchError(e => of(new facet.LoadFailed(e))),)
            ))

    @Effect()
    applyFacets$: Observable<Action> = 
        this.actions$.ofType<facet.Apply>(facet.APPLY).pipe(
            withLatestFrom(
                this.store.pipe(select(fromOrders.isInitialized)),
                (action, initialized) => initialized
            ),
            filter(initialized => initialized),
            switchMap(initialized => 
                of(new facet.Load() as Action, new order.Load())
            ))
}
